import { SyllabusAction } from '../types/SyllabusAction';
import ContentTagData from '../types/ContentTagData';
import { any } from 'prop-types';

interface syllabusState {
	testId: string | any,
	subjects: any[],
	subject: any,
	loading: boolean,
	modalTrigger: any,
	error: string | any,
	selectedQuestions:any[];
	contentCount: number;
	loadingCount: boolean;
};

const initialState: syllabusState = {
	testId: null,
	subjects: [],
	subject: null,
	loading: false,
	modalTrigger: undefined,
	error: null,
	selectedQuestions:[],
	contentCount: 0,
	loadingCount: false
};

const syllabusReducers = (state = initialState, action: SyllabusAction) => {
	switch (action.type) {
		case 'FETCH_SUBJECTS_SUCCESS': {
			return { ...state, subjects: action.payload, loading: false }
		}
		case 'FETCH_SUBJECTS_FAILED': {
			return { ...state, error: action.error, loading: false }
		}
		case 'UPDATE_SUBJECT': {
			return { ...state, subject: action.payload, loading: true }
		}
		case 'UPDATE_SUBJECT_SUCCESS': {
			return { ...state, subjects: action.payload, loading: false }
		}
		case 'UPDATE_SUBJECT_FAILED': {
			return { ...state, error: action.error, loading: false }
		}
		case 'FETCH_SUBJECTS': {
			return { ...state, loading: true }
		}
		case 'UPDATE_TEST_ID': {
			return { ...state, testId: action.payload }
		}
		case 'SET_MODAL_FUNCTION': {
			return { ...state, modalTrigger: action.payload }
		}
		case 'GET_AUTO_GENERATE_SUCCESS':{
			return {...state, selectedQuestions:action.payload.selectedQuestions}
		}
		case "GET_COUNT_AUTO_GENERATE": {
			return {...state, loadingCount: true}
		}
		case "GET_COUNT_AUTO_GENERATE_FAILURE": {
			return {...state, loadingCount: false}
		}
		case 'GET_COUNT_AUTO_GENERATE_SUCCESS':{
			return {...state, contentCount:action.payload, loadingCount: false}
		}
		default:
			return state;
	}
}


export default syllabusReducers;